export default __webpack_public_path__ + "static/media/legalPage.109606bf.jpg";